import { UserResponseTypes } from "backend";
import { Requests } from "../common/request.common";
import { get, post } from "./common";

export const user = {
    login(data: typeof Requests.User.Login.Input) {
        return post<typeof data>("/login", data);
    },
    profile() {
        return get<UserResponseTypes.Profile>("/profile");
    },
    userProfile() {
        return get<UserResponseTypes.UserProfile>("/user-profile");
    },
    userProfileUpdate(data: typeof Requests.User.Update.Input) {
        return post<typeof data>("/user-profile/update", data);
    },
    userProfileUpdatePassword(data: typeof Requests.User.UpdatePassword.Input) {
        return post<typeof data>("/user-profile/update-password", data);
    },
};
